export enum SpeechLocation {
  RIGHT = 'right',
  LEFT = 'left',
}
